module.exports = __webpack_public_path__ + "img/aib.a77e8e6.svg";